<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="back()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'BTN.preview' | translate }}</ion-title>
    <ion-buttons slot="end" *ngIf="showMobileBoolean">
      <ion-button (click)="toggleMobileMode()">
        <ion-icon slot="icon-only" color="dark" name="phone-portrait-outline" *ngIf="!mobileMode"></ion-icon>
        <ion-icon slot="icon-only" color="dark" name="phone-portrait" *ngIf="mobileMode"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content #content>
  <app-website-component [previewMode]="true" [pageMode]="false" [mobileMode]="mobileMode" [accountId]="accountInfo?.accountId" [accountInfo]="accountInfo" [accountId]="accountInfo?.accountId" [setWebsiteDetail]="websiteDetail" [websiteLink]="websiteLink" [setReady]="ready" *ngIf="accountInfo && websiteDetail"></app-website-component>
</ion-content>